import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, hasPermission } from '@/lib/auth';

/**
 * Wraps the whole /supervisor tree. Gated on orders.facility.edit specifically
 * (not AdminGuard's broader admin-panel permission set) per the Phase 11 spec
 * -- a supervisor gets a purpose-built working surface, same reasoning as
 * DriverGuard/driver: someone holding only facility permissions has no
 * business being bounced into /admin's dashboard shell first.
 *
 *   - No session → /login with a return URL
 *   - Authed but doesn't hold it → /account
 *   - Holds it → render children
 */
export function SupervisorGuard({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const isAuthed = useAuthStore((s) => s.isAuthenticated());
  const loc = useLocation();

  if (!isAuthed || !user) {
    return <Navigate to={`/login?return=${encodeURIComponent(loc.pathname)}`} replace />;
  }
  if (!hasPermission(user, 'orders.facility.edit')) {
    return <Navigate to="/account" replace />;
  }
  return <>{children}</>;
}
